import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
    propertyRow: {
        alignItems: "center",
    },
    iconPositive: {
        color: theme.palette.emteria.success,
    },
    iconWarning: {
        color: theme.palette.emteria.warning,
    },
    iconNegative: {
        color: theme.palette.emteria.error,
    },
    iconNeutral: {
        color: theme.palette.emteria.text.secondary,
    },
    valueWithIcon: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
    },
    usbDevicesList: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(3),
    },
    usbDeviceTitle: {
        fontWeight: 600,
        marginBottom: theme.spacing(1),
    },
}));
